import { Box, FormErrorMessage } from '@chakra-ui/react';

export const FormError = ({ children }: { children: string | null | undefined }) => {
  return children ? <FormErrorMessage>{children}</FormErrorMessage> : <Box minHeight={6}></Box>;
};
